// extracted by mini-css-extract-plugin
export default {"container":"rating_container__brS1j","count":"rating_count__CycDR","icon":"rating_icon__oRNMj"};